// extracted by mini-css-extract-plugin
export var actionButton = "_a1-0";
export var attachmentLine = "_a1-1";
export var fileInput = "_a1-2";
export var fileUploadWrapper = "_a1-4";
export var footer = "_a1-3";
export var modalContent = "_a1-5";
export var paperclip = "_a1-6";
export var quillEditor = "_a1-7";